import { IncomingMessage } from 'http'
import { S_DEBUG_MODE } from './config'

export async function setNoCacheHeaders(res: any) {
  return new Promise<any>(async (resolve) => {
    let ret: any = res
    try {
      if (ret) {
        res.setHeader('Cache-Control', 'no-cache, no-store, must-revalidate')
        res.setHeader('Pragma', 'no-cache')
        res.setHeader('Expires', '0')
      }
    } catch (e) {
      if (S_DEBUG_MODE) console.log(e)
    } finally {
      resolve(ret)
    }
  })
}

export async function generateCacheKey(input: any): Promise<string> {
  return new Promise<any>(async (resolve) => {
    let ret: string = ''
    try {
      const serialized = JSON.stringify(input, Object.keys(input).sort())
      const msgUint8: any = new TextEncoder().encode(serialized)
      const hashBuffer: ArrayBuffer = await crypto.subtle.digest(
        'SHA-256',
        msgUint8
      )
      const hashArray: number[] = Array.from(new Uint8Array(hashBuffer))
      ret = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
    } catch (e) {
      if (S_DEBUG_MODE) console.log(e)
    } finally {
      resolve(ret)
    }
  })
}

export const hasMappedHeaders = (
  headers: Headers | IncomingMessage['headers']
): headers is Headers => {
  let ret: boolean = false
  try {
    ret = headers instanceof Headers
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
  }
  return ret
}
